import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import SalePoint from "../references/Klients/salePoint";
import SalePointsList from "../references/SalePointsList";

class FragmentSalePoints extends BaseComponent {
    constructor(props) {
        super(props);
        const state = {
            activePanelSalePoints: "panel_salepoints_list",
            current_sale_point_ref: null,
            listState: null,
        };

        this.state = {
            ...this.state,
            ...state
        };
    }

    saveListState = (listState) => {
        this.setState({listState});
    }

    editCurrentSalePoint = (e, fieldName) => {
        const {current_sale_point_ref} = this.state;
        if (!current_sale_point_ref) {
            return;
        }

        if (e.unrestricted_value !== undefined) {
            current_sale_point_ref.dadata_object = e;
            current_sale_point_ref.full_address = e.value;
        } else {
            current_sale_point_ref[fieldName] = e.currentTarget.value;
        }
        this.setState({current_sale_point_ref});
    }

    receiveMessage = (event) => {
        if (event.data && event.data.type === 'reloadCurrentList') {
            this.setState({listState: null});
        }
        if (event.data.type !== undefined && event.data.type === 'setCurrentSalePointRef') {
            this.setState({
                current_sale_point_ref: event.data.value,
                activePanelSalePoints: event.data.value && event.data.value.id ? 'panel_salepoints_item' : 'panel_salepoints_list'
            });
            return;
        }
    }

    render() {
        return <View activePanel={this.state.activePanelSalePoints} id="salepoints_story">
            <Panel id="panel_salepoints_list">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <SalePointsList
                            current_user={this.props.current_user}
                            base_url={this.state.base_url}
                            savedListState={this.state.listState}
                            onSaveListState={this.saveListState}
                        />
                    </SplitCol>
                </SplitLayout>
            </Panel>

            <Panel id="panel_salepoints_item">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <SalePoint
                            current_user={this.props.current_user}
                            item={this.state.current_sale_point_ref}
                            base_url={this.state.base_url}
                            change={this.editCurrentSalePoint}
                            messageType="setCurrentSalePointRef"
                            hideForm={() => this.setState({
                                current_sale_point_ref: null,
                                activePanelSalePoints: 'panel_salepoints_list'
                            })}
                        />
                    </SplitCol>
                </SplitLayout>
            </Panel>
        </View>;
    }
}

export default FragmentSalePoints;
